export default __webpack_public_path__ + "static/media/noun-overdue.e0a96b94.svg";